<!-- 组合推荐的子组件：大图设置商品的锚点 -->
<template>
  <div class="compose-image">
    <!-- 大图 -->
    <div class="compose-image__body">
      <div 
        :style="{
          backgroundImage: `url(${tagsConfig.image.url})`,
          backgroundSize: 'cover',
          backgroundPosition: tagsConfig.position,
          height: 0,
          paddingBottom: '100%'
        }"
      >
      </div>
    </div>
    <!-- 商品锚点 -->
    <div class="compose-image__tags" >
      <div
        v-for="(tag, index ) in tagsConfig.img_tag"
        class="model"
        :class="[`model_${tagsConfig.styles}_${index}`,tag.rotate?'model--right':'']"
        :key="tag.product_id"
      >
        <template v-for="(p ,i) in products">
          <template  v-if="p.ID == tag.product_id" >
            <!-- 锚点图标 -->
            <div class="model__icon" @click="tagOnClick(tag,index)" v-if="products.length>0" :key="'icon-'+i">
              <div class="outside" :style="{background:tagsConfig.background_color}">
                <div class="inside" :style="{background:tagsConfig.points_color}">
                </div>
              </div>
            </div>
            <!-- 锚点title -->
            <div :class="['model__title--'+tagsConfig.styles]" v-if="products.length>0" :key="'title-'+i" >
              <div class="titile-icon">
                <svg viewBox="64 64 896 896" focusable="false" data-icon="shopping" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                  <path d="M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"></path>
                </svg>
              </div>
              <div class="title-text" >{{p.title}}</div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VImgCard from '@/js/components/common/imgCard.vue'; 

export default {
  name: 'ComposeImage',
  props: {
    //锚点配置
    tagsConfig: {
      type: Object,
      default: null
    },
    //当前显示的商品id
    currentProductId: {
      type: Number,
      default: null
    },
    //商品列表
    products: {
      type: Array,
      default: null
    }
  },
  components: {
    VImgCard,
  },
  methods: {
    //锚点点击事件
    tagOnClick(item,index) {
      if(this.tagsConfig.styles == 1) {
        this.tagsConfig.img_tag?.map(((el, i) => {
          this.$(`.model_1_${i}`).children().last().css('display','none')
        }))
        this.$(`.model_1_${index}`).children().last().css('display','flex')
      }else {
        this.tagsConfig.img_tag?.map(((el, i) => {
          this.$(`.model_2_${i}`).css('z-index',1)
        }))
        this.$(`.model_2_${index}`).css('z-index',2)
      }
      this.$emit('changeCurrentProductId',item.product_id) 
    },
  },
  mounted() {
    //设置锚点位置，默认样式
    let imgWidth = this.$('.compose-image__body')[0].clientWidth
    this.$el.style.setProperty(`--content-img-width`,imgWidth*220/700+'px')
    this.tagsConfig.img_tag?.map((item, index) => {
      this.$el.style.setProperty(`--content-top-${index}`, item.percentage_y*100+'%');
      // 在锚点文本在右时会出现一段位置偏移误差 1：由admin修改获取正确的坐标 2：由商城侧模拟一个近似的误差值进行修正 (item.percentage_x + (item.rotate?0.028:0))*100
      this.$el.style.setProperty(`--content-left-${index}`, item.percentage_x*100+'%');
      console.log('---',imgWidth,item.width,(imgWidth * (item.width - 20)) / 700 - 25 + 'px' );
      this.$el.style.setProperty(`--content-title-width-${index}`,(imgWidth * (item.width - 20)) / 700 - 25 + 'px' )
      if(this.tagsConfig.styles == 1) {
        this.$(`.model_1_${index}`).children().last().css('display','none')
      }else {
         this.$(`.model_2_${index}`).css('z-index',1)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.compose-image {
  --content-img-width: 0;
  --content-top-0: 0;
  --content-left-0: 0;
  --content-title-width-0: 0;
  --content-top-1: 0;
  --content-left-1: 0;
  --content-title-width-1: 0;
  --content-top-2: 0;
  --content-left-2: 0;
  --content-title-width-2: 0;
  --content-top-3: 0;
  --content-left-3: 0;
  --content-title-width-3: 0;
  --content-top-4: 0;
  --content-left-4: 0;
  --content-title-width-4: 0;
  position: relative;
  &__body {
    img {
      width: 100%;
    }
  }
  &__tags {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    .model {
      position: absolute;
      display: flex;
      align-items: center;
      &__icon {
        margin: 10px;
        cursor: pointer;
        .outside {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          padding: 5px;
          .inside {
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
        }
      }
      &__title--1,&__title--2 {
        position: absolute;
        left: 85%;
        right: auto;
        height: 38px;
        line-height: 38px;
        padding-right: 14px;
        width: max-content;
        //max-width: calc(var(--content-img-width) - 20px);
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        opacity: 0.8;
        display: flex;
        .title-text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: none;
        }
        .titile-icon{
          margin-right: 10px;
        }
      }
      &__title--2 {
        background: #FFFFFF;
        padding-left: 30px;
        color: #222222;
        clip-path: polygon(26px 0px, 100% 0, 100% 0, 100% 100%, 100% 100%, 26px 100%, 0 50%, 0 50%);
      }
      &__title--1 {
        background: #000000;
        border-radius: 10px;
        padding-left: 14px;
        color: #FFFFFF;
      }
    }
    .model--right{
      flex-direction: row-reverse;
      .model__title--1,.model__title--2 {
        right: 85% !important;
        left: auto !important;
        transform: rotate(180deg);
        transform-origin: center;
        .title-text,.titile-icon{
          transform: rotate(180deg);
        }
      }
    }
    .model_1_0,.model_2_0{
      top: calc(var(--content-top-0) - 22px);
      left: calc(var(--content-left-0) - 22px);
      .model__title--1{
        max-width: var(--content-title-width-0);
      }
      .model__title--2 {
        max-width: calc( var(--content-title-width-0) + 44px);
      }
    }
    .model_1_1,.model_2_1{
      top: calc(var(--content-top-1) - 22px);
      left: calc(var(--content-left-1) - 22px);
      .model__title--1{
        max-width: var(--content-title-width-1);
      }
      .model__title--2 {
        max-width: calc( var(--content-title-width-1) + 44px);
      }
    }
    .model_1_2,.model_2_2{
      top: calc(var(--content-top-2) - 22px);
      left: calc(var(--content-left-2) - 22px);
      .model__title--1{
        max-width: var(--content-title-width-2);
      }
      .model__title--2 {
        max-width: calc( var(--content-title-width-2) + 44px);
      }
    }
    .model_1_3,.model_2_3{
      top: calc(var(--content-top-3) - 22px);
      left: calc(var(--content-left-3) - 22px);
      .model__title--1{
        max-width: var(--content-title-width-3);
      }
      .model__title--2 {
        max-width: calc( var(--content-title-width-3) + 44px);
      }
    }
    .model_1_4,.model_2_4{
      top: calc(var(--content-top-4) - 22px);
      left: calc(var(--content-left-4) - 22px);
      .model__title--1{
        max-width: var(--content-title-width-4);
      }
      .model__title--2 {
        max-width: calc( var(--content-title-width-4) + 44px);
      }
    }
  }
}
@media (max-width: 767px) {
  .compose-image {
    &__tags {
      .model {
        &__icon {
          margin: 5px;
          .outside {
            width: 12px;
            height: 12px;
            padding: 3px;
            .inside {
              width: 6px;
              height: 6px;
            }
          }
        }
        &__title--1,&__title--2 {
          display: none !important;
          height: 24px;
          line-height: 24px;
          padding-right: 10px;
          font-size: 10px;
          .titile-icon{
            margin-right: 0 7px;
          }
        }
        &__title--2 {
          padding-left: 20px;
          clip-path: polygon(15px 0px, 100% 0, 100% 0, 100% 100%, 100% 100%, 15px 100%, 0 50%, 0 50%);
        }
        &__title--1 {
          padding-left: 7px;
        }
        &__title--right {
          transform-origin: -11px center;
        }
      }
      .model_1_0,.model_2_0{
        top: calc(var(--content-top-0) - 11px);
        left: calc(var(--content-left-0) - 11px);
      }
      .model_1_1,.model_2_1{
        top: calc(var(--content-top-1) - 11px);
        left: calc(var(--content-left-1) - 11px);
      }
      .model_1_2,.model_2_2{
        top: calc(var(--content-top-2) - 11px);
        left: calc(var(--content-left-2) - 11px);
      }
      .model_1_3,.model_2_3{
        top: calc(var(--content-top-3) - 11px);
        left: calc(var(--content-left-3) - 11px);
      }
      .model_1_4,.model_2_4{
        top: calc(var(--content-top-4) - 11px);
        left: calc(var(--content-left-4) - 11px);
      }
    }
  }
}
</style>